/*
 * ============================================================
 * argile.js — noyau front global (vanilla, 0 dépendance)
 * ============================================================
 * Chargé en <head> avec `defer` (voir snippets/argile-head.liquid), sur toutes
 * les pages. Ne contient QUE le transverse (présent un peu partout).
 *
 * Convention Argile : « 1 section = son JS ». Le comportement spécifique à une
 * section vit dans son propre fichier (assets/argile-<section>.js), chargé PAR
 * la section, et non ici. Voir argile-navbar.js / argile-announcement.js /
 * argile-slider.js / argile-feature-tabs.js / argile-video.js.
 *
 * Fournit ici :
 *   - reveal-on-scroll : révèle les éléments `.argile-reveal` (IntersectionObserver)
 *
 * Idempotent + ré-init sur `shopify:section:load` (éditeur de thème).
 */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --------------------------------------------------------
   * Reveal-on-scroll — cible tout `.argile-reveal` pas encore révélé.
   * -------------------------------------------------------- */
  function initReveal(root) {
    var scope = root || document;
    var targets = scope.querySelectorAll('.argile-reveal:not(.is-visible)');
    if (!targets.length) return;

    // Pas d'observer (vieux navigateur) ou reduced-motion → tout visible.
    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        });
      },
      // threshold 0 (et non 0.1) : un élément plus HAUT que le viewport — ex. la
      // grille mono-colonne des points de vente en mobile — ne peut jamais atteindre
      // un ratio de 0.1, il resterait invisible. isIntersecting + rootMargin bas -10%
      // suffit à déclencher « un peu après l'entrée » quelle que soit la hauteur.
      { rootMargin: '0px 0px -10% 0px', threshold: 0 }
    );

    targets.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initReveal(document); });
  } else {
    initReveal(document);
  }

  // Éditeur de thème : ré-observe les éléments d'une section rechargée.
  document.addEventListener('shopify:section:load', function (event) {
    initReveal(event.target);
  });
})();
